import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import MotionTrack from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack';
import MotionTrackStyles from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack.styles';
import PaginationStyles from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination.styles';
import HeadingSummaryBlockStyles from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  ${HeadingSummaryBlockStyles.Container} {
    margin-bottom: ${fluid(32, 76)};

    @media ${until(Device.TabletLarge)} {
      align-items: center;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  ${HeadingSummaryBlockStyles.Subheading} {
    @media ${until(Device.TabletLarge)} {
      margin-bottom: 8px;
    }
  }

  ${HeadingSummaryBlockStyles.Heading} {
    font-size: ${fluid(32, 48)};
    line-height: ${fluid(40, 56)};

    @media ${until(Device.TabletLarge)} {
      margin-bottom: 16px;
    }
  }

  ${HeadingSummaryBlockStyles.ContentWrapper} {
    max-width: 695px;
  }
`;
const Title = styled.h2 `
  ${fonts.intro};
  font-size: ${fluid(20, 24)};
  line-height: ${fluid(26, 28)};
  text-transform: uppercase;
  color: ${brand.primary.purple.light};
  margin-bottom: ${fluid(16, 19)};
`;
const Item = styled.li `
  display: block;
  flex: 0 0 calc(100% / var(--visibleItems) - (var(--itemPeek, 0px) / var(--visibleItems)));
  padding: 0 calc(var(--itemGutter) / 2);
`;
const CarouselWrapper = styled.div `
  --itemPeek: 16px;
  --itemGutter: var(--gutterWidth, 12px);
  --visibleItems: 1;

  margin: 0 calc(var(--itemGutter) * -0.5);

  ${Container}:not(:has(${Item}:nth-child(2))) & {
    --itemPeek: 0px;
  }

  ${PaginationStyles.Container} {
    margin: 22px 0 0;

    @media ${from(Device.Tablet)} {
      display: none;
    }
  }

  @media ${from(Device.Tablet)} {
    --visibleItems: 2;
  }

  @media ${from(Device.Desktop)} {
    ${baseGrid};

    --itemPeek: 0px;
    --visibleItems: 3;
  }
`;
const Track = styled(MotionTrack) `
  @media ${from(Device.Tablet)} {
    ${MotionTrackStyles.Track} {
      row-gap: var(--itemGutter);
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  @media ${from(Device.Desktop)} {
    ${Container}:not(:has(${Item}:nth-child(2))) & {
      grid-column: 4 / span 6;

      ${Item} {
        flex: 1 1 695px;
      }
    }

    ${Container}:not(:has(${Item}:nth-child(3))) & {
      grid-column: 2 / span 10;

      ${Item} {
        flex: 0 0 50%;
      }
    }

    ${Container}:has(${Item}:nth-child(3)) & {
      grid-column: 1 / span 12;
    }
  }
`;
const PeopleCardsStyles = {
    CarouselWrapper,
    Container,
    Item,
    Title,
    Track,
};
export default PeopleCardsStyles;
